import * as React from "react";
import PropTypes from "prop-types";
import Box from "@mui/material/Box";
import Collapse from "@mui/material/Collapse";
import IconButton from "@mui/material/IconButton";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import SelectMenuEmployee from "./SelectMenuEmployee";

function createData(Module, Add, View, Update, Delete) {
  return {
    Module,
    Add,
    View,
    Update,
    Delete,
    history: [],
  };
}

function Row(props) {
  const { row } = props;
  const [open, setOpen] = React.useState(false);

  return (
    <React.Fragment>
      <TableRow sx={{ "& > *": { borderBottom: "unset", color: "black" } }}>
        <TableCell component="th" scope="row">
          {row.Module}
        </TableCell>
        <TableCell align="right">{row.Add}</TableCell>
        <TableCell align="right">{row.View}</TableCell>
        <TableCell align="right">{row.Update}</TableCell>
        <TableCell align="right">{row.Delete}</TableCell>
        <TableCell>
          <IconButton
            aria-label="expand row"
            size="small"
            sx={{
              color: "#000",
            }}
            onClick={() => setOpen(!open)}
          >
            {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
          </IconButton>
        </TableCell>
      </TableRow>
      <TableRow>
        <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={6}>
          <Collapse in={open} timeout="auto" unmountOnExit>
            <Box sx={{ margin: 1, bgcolor: "white", color: "black" }}>
              <Table size="small" aria-label="purchases">
                <TableHead>
                  <TableRow>
                    <TableCell sx={{ color: "#000" }}>
                      Add Assets Type
                    </TableCell>
                    <TableCell sx={{ color: "#000" }}>
                      Edit Assets Type
                    </TableCell>
                    <TableCell align="right" sx={{ color: "#000" }}>
                      View Assets Type
                    </TableCell>
                    <TableCell align="right" sx={{ color: "#000" }}>
                      Delete Assets Type
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  <TableRow>
                    <TableCell>
                      <SelectMenuEmployee menu={menu[0]} />
                    </TableCell>
                    <TableCell>
                      <SelectMenuEmployee menu={menu[0]} />
                    </TableCell>
                    <TableCell align="right">
                      <SelectMenuEmployee menu={menu[0]} />
                    </TableCell>
                    <TableCell align="right">
                      <SelectMenuEmployee menu={menu[0]} />
                    </TableCell>
                  </TableRow>
                </TableBody>
              </Table>
            </Box>
          </Collapse>
        </TableCell>
      </TableRow>
    </React.Fragment>
  );
}

Row.propTypes = {
  row: PropTypes.shape({
    Module: PropTypes.string.isRequired,
    Add: PropTypes.node.isRequired,
    View: PropTypes.node.isRequired,
    Update: PropTypes.node.isRequired,
    Delete: PropTypes.node.isRequired,
    history: PropTypes.arrayOf(
      PropTypes.shape({
        date: PropTypes.string,
        customerId: PropTypes.string,
        amount: PropTypes.number,
      })
    ),
  }).isRequired,
};

const menu = [
  ["None", "All"],
  ["None", "All", "Added", "Owned", "Added and Owned"],
  ["None", "All", "Added", "Owned", "Added and Owned"],
  ["None", "All", "Added", "Owned", "Added and Owned"],
  ["None", "All"],
];
const rows = [
  createData(
    "Assets",
    <SelectMenuEmployee menu={menu[0]} />,
    <SelectMenuEmployee menu={menu[1]} />,
    <SelectMenuEmployee menu={menu[2]} />,
    <SelectMenuEmployee menu={menu[3]} />,
    <SelectMenuEmployee menu={menu[4]} />
  ),
];

export default function PermissionEmployee() {
  return (
    <TableContainer component={Paper} sx={{ bgcolor: "white", color: "black" }}>
      <Table aria-label="collapsible table">
        <TableHead>
          <TableRow>
            <TableCell sx={{ color: "#000" }}>Module</TableCell>
            <TableCell align="right" sx={{ color: "#000" }}>
              Add
            </TableCell>
            <TableCell align="right" sx={{ color: "#000" }}>
              View
            </TableCell>
            <TableCell align="right" sx={{ color: "#000" }}>
              Update
            </TableCell>
            <TableCell align="right" sx={{ color: "#000" }}>
              Delete
            </TableCell>
            <TableCell />
          </TableRow>
        </TableHead>
        <TableBody>
          {rows.map((row) => (
            <Row key={row.Module} row={row} />
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
